export const ERROR_UPLOADING = 'uploading';
export const STYLING_DEFAULT_ERROR_MESSAGE = 'stylingDefaultError';
export const ERROR_TYPE_CHECKOUT_V2_REQUIRED = 'checkoutV2Required';
